import { a11yOnly } from "styles/global.css";

/**
 * @param {string} data - data to put on the clipboard
 */
export default (data) => {
  document.getSelection().removeAllRanges();

  const copyInput = document.createElement("input");
  copyInput.classList = a11yOnly;
  copyInput.style.position = "fixed";
  copyInput.style.zIndex = -100;
  copyInput.style.top = "42vh";
  copyInput.value = data;
  document.body.appendChild(copyInput);
  copyInput.focus();
  copyInput.setSelectionRange(0, copyInput.value.length);
  if (document.queryCommandSupported("copy") && document.execCommand("copy")) {
    copyInput.blur();
    document.body.removeChild(copyInput);
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/utils/clipboard.js